module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/target-8437b01678773fbdb011ab8a7dd2fa9b.svg";